import { MediaQueries } from 'UI'

export default theme => ({
  ResultInfos: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 61
  },
  iconClass: {
    color: theme.secondary[0]
  },
  [`${MediaQueries.tablet}`]: {
    ResultInfos: {
      marginBottom: 21
    }
  },
  [`${MediaQueries.mobile}`]: {
    ResultInfos: {
      marginBottom: 21
    }
  }
})
